import { z } from "zod";

export const paymentFormSchema = z.object({
    storeCard: z.boolean(),
});

export type PaymentFormType = z.infer<typeof paymentFormSchema>;

export const generatePaymentFormDefaultValues = (isLoggedIn: boolean) => {
    return { storeCard: isLoggedIn } as PaymentFormType;
};
